export const Referrers = {
  contentManager: 'contentManager',
  personalization: 'personalization',
  contentStaging: 'contentStaging',
  pageSettings: 'pageSettings',
  pageDetails: 'pageDetails',
  pageEditor: 'pageEditor',
  brandingSettings: 'brandingSettings',
  userGuide: 'userGuide',
  themeEditor: 'themeEditor',
  marketplaceDownloads: 'marketplaceDownloads',
  growthPlan: 'growthPlan'
};